<div class="rr-tags">
  <rr-tag
    *ngFor="let tag of tagsToDisplay"
    [tag]="tag"
    [showRemoveButton]="showRemoveButton"
    [hasClickAction]="hasClickAction"
    (tagClicked)="onTagClicked($event)"
    (removeClicked)="onRemoveTagClicked($event)"
  >
  </rr-tag>
</div>
